import type { MqttConnector } from '@/types/auth'

/**
 * 将登录返回的 tcp connector 转为浏览器可用的 ws/wss 地址。
 * 规则：根据当前页面协议选择 ws 或 wss，路径固定为 /mqtt
 */
export function buildMqttWsUrl(connector: MqttConnector): string {
	const { host } = connector.server
	const useSecure = typeof window !== 'undefined' && window.location.protocol === 'https:'
	const protocol = useSecure ? 'wss' : 'ws'
	const isTestEnv = import.meta.env.MODE === 'test' || import.meta.env.MODE === 'development'

	if (isTestEnv) {
		const protocolPort = 3884
		return `${protocol}://${host}:${protocolPort}/mqtt`
	}
	return `${protocol}://${host}/mqtt`
}
